import { useEffect, useState } from "react";

export const useAutoSave = (
  saveFunction: () => Promise<boolean>,
  updates: number,
  resetUpdates: () => void,
  intervalMs: number = 5000
) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Don't start interval if no updates or skipAutosave is true
    if (updates === 0) return;

    const save = () => {
      setIsLoading(true);
      saveFunction()
        .then((success) => {
          if (success) {
            resetUpdates();
          }
        })
        .catch((error) => console.error("Error saving", error))
        .finally(() => setIsLoading(false));
    };

    const intervalId = setInterval(save, intervalMs);

    return () => clearInterval(intervalId);
  }, [updates, saveFunction, resetUpdates, intervalMs]);

  return { isSaving: isLoading };
};
